import { render } from "./ourServices.vue?vue&type=template&id=6a9fefee&scoped=true"
import script from "./ourServices.vue?vue&type=script&lang=js"
export * from "./ourServices.vue?vue&type=script&lang=js"

import "./ourServices.vue?vue&type=style&index=0&id=6a9fefee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9fefee"]])

export default __exports__